import React, { useMemo } from 'react'
import RmaDetails from './rmaDetails/RMADetails'
import ReturnItemContextProvider from '../../../../contexts/ReturnItemContextProvider'
import SelectedItemsContextProvider from '../../../../contexts/SelectedItemsContextProvider'
import LifetimeReplacement from './lifetimeReplacement/LifetimeReplacement'
import { returnType } from '../../OrderHistory/components/buttons/manageButtonType'

const RMADetailModule = ({ data }) => {
  const { type } = { ...data }

  const Component = useMemo(() => {
    if (type === returnType.lifetime) return LifetimeReplacement

    return RmaDetails
  }, [type])

  return (
    <ReturnItemContextProvider>
      <SelectedItemsContextProvider>
        <Component moduleData={data} />
      </SelectedItemsContextProvider>
    </ReturnItemContextProvider>
  )
}

export default RMADetailModule
